<template>
  <div class="special-root">
    <div v-if="loading" class="special-loading-overlay flex-col">
      <span class="special-loading-text">加载中...</span>
    </div>
    <div v-show="!loading" class="special-page">
      <component
        v-for="item in visibleComponents"
        :key="item.uniqueKey"
        :is="componentMap[item.componentKey]"
        :ref="item.refName"
        :component-id="item.componentId"
      />
    </div>
  </div>
</template>

<script>
import { fetchSpecialInfo } from '../../api'
import PageHeader from '../detail/components/PageHeader.vue'
import PageFooter from '../detail/components/PageFooter.vue'

// SpecialOne 组件
import SpOneTopBanner from './SpecialOne/components/TopBanner.vue'
import SpOneHeroCarousel from './SpecialOne/components/HeroCarousel.vue'
import SpOneHeroCarouselPanel from './SpecialOne/components/HeroCarouselPanel.vue'
import SpOneEventSeries from './SpecialOne/components/EventSeries.vue'
import SpOneHighlightsGrid from './SpecialOne/components/HighlightsGrid.vue'
import SpOneGuestShowcase from './SpecialOne/components/GuestShowcase.vue'
import SpOneAgendaSection from './SpecialOne/components/AgendaSection.vue'
import SpOneAddressSection from './SpecialOne/components/AddressSection.vue'
import SpOneHostSection from './SpecialOne/components/HostSection.vue'
import SpOneCoreActivities from './SpecialOne/components/CoreActivities.vue'
import SpOneReviewSection from './SpecialOne/components/ReviewSection.vue'
import SpOneReviewGala from './SpecialOne/components/ReviewGala.vue'
import SpOneOrganizations from './SpecialOne/components/Organizations.vue'
import SpOnePartners from './SpecialOne/components/Partners.vue'
import SpOneMediaCooperation from './SpecialOne/components/MediaCooperation.vue'
import SpOneSpecialTitle from './SpecialOne/components/SpecialOneTitle.vue'

// SpecialSix 组件
import SpSixHeroBanner from './SpecialSix/components/HeroBanner.vue'
import SpSixHeroSection from './SpecialSix/components/HeroSection.vue'
import SpSixNewsSection from './SpecialSix/components/NewsSection.vue'
import SpSixPartnerSection from './SpecialSix/components/PartnerSection.vue'
import SpSixCultivationSection from './SpecialSix/components/CultivationSection.vue'
import SpSixStorySection from './SpecialSix/components/StorySection.vue'
import SpSixTitle from './SpecialSix/components/SpecialSixTitle.vue'

// SpecialTwo 组件
import SpTwoModule1 from './SpecialTwo/components/SpTwoModule1.vue'
import SpTwoModule2 from './SpecialTwo/components/SpTwoModule2.vue'
import SpTwoModule3 from './SpecialTwo/components/SpTwoModule3.vue'
import SpTwoModule4 from './SpecialTwo/components/SpTwoModule4.vue'
import SpTwoModule5 from './SpecialTwo/components/SpTwoModule5.vue'
import SpTwoModule6 from './SpecialTwo/components/SpTwoModule6.vue'

// SpecialThree 组件
import SpThreeModule1 from './SpecialThree/components/SpThreeModule1.vue'
import SpThreeModule2 from './SpecialThree/components/SpThreeModule2.vue'
import SpThreeModule3 from './SpecialThree/components/SpThreeModule3.vue'

// SpecialFour 组件
import SpFourModule1 from './SpecialFour/components/SpFourModule1.vue'
import SpFourModule2 from './SpecialFour/components/SpFourModule2.vue'
import SpFourModule3 from './SpecialFour/components/SpFourModule3.vue'
import SpFourModule4 from './SpecialFour/components/SpFourModule4.vue'

// SpecialSeven 组件
import SpSevenModuleOne from './SpecialSeven/components/SpSevenModuleOne.vue'
import SpSevenModuleTwo from './SpecialSeven/components/SpSevenModuleTwo.vue'
import SpSevenModuleThree from './SpecialSeven/components/SpSevenModuleThree.vue'
import SpSevenModuleFour from './SpecialSeven/components/SpSevenModuleFour.vue'
import SpSevenModuleMore from './SpecialSeven/components/SpSevenModuleMore.vue'
import SpSevenYear from './SpecialSeven/components/SpSevenYear.vue'

// 通用组件
import SpImage from './components/SpImage.vue'
import SpText from './components/SpText.vue'

const componentMap = {
  header: PageHeader,
  bottom: PageFooter,

  // SpecialOne
  sp_one_module_1: SpOneTopBanner,
  sp_one_module_2: SpOneHeroCarousel,
  sp_one_module_3: SpOneHeroCarouselPanel,
  sp_one_module_4: SpOneEventSeries,
  sp_one_module_5: SpOneHighlightsGrid,
  sp_one_module_6: SpOneGuestShowcase,
  sp_one_module_7: SpOneAgendaSection,
  sp_one_module_8: SpOneAddressSection,
  sp_one_module_9: SpOneHostSection,
  sp_one_module_10: SpOneCoreActivities,
  sp_one_module_11: SpOneReviewSection,
  sp_one_module_12: SpOneReviewGala,
  sp_one_module_13: SpOneOrganizations,
  sp_one_module_14: SpOnePartners,
  sp_one_module_15: SpOneMediaCooperation,
  sp_one_title: SpOneSpecialTitle,

  // SpecialSix
  sp_six_module_1: SpSixHeroBanner,
  sp_six_module_2: SpSixHeroSection,
  sp_six_module_3: SpSixNewsSection,
  sp_six_module_4: SpSixPartnerSection,
  sp_six_module_5: SpSixCultivationSection,
  sp_six_module_6: SpSixStorySection,
  sp_six_title: SpSixTitle,

  // SpecialTwo
  sp_two_module_1: SpTwoModule1,
  sp_two_module_2: SpTwoModule2,
  sp_two_module_3: SpTwoModule3,
  sp_two_module_4: SpTwoModule4,
  sp_two_module_5: SpTwoModule5,
  sp_two_module_6: SpTwoModule6,

  // SpecialThree
  sp_three_module_1: SpThreeModule1,
  sp_three_module_2: SpThreeModule2,
  sp_three_module_3: SpThreeModule3,

  // SpecialFour
  sp_four_module_1: SpFourModule1,
  sp_four_module_2: SpFourModule2,
  sp_four_module_3: SpFourModule3,
  sp_four_module_4: SpFourModule4,

  // SpecialSeven
  sp_seven_module_one: SpSevenModuleOne,
  sp_seven_module_two: SpSevenModuleTwo,
  sp_seven_module_three: SpSevenModuleThree,
  sp_seven_module_four: SpSevenModuleFour,
  sp_seven_module_more: SpSevenModuleMore,
  sp_seven_year: SpSevenYear,

  // 通用组件
  sp_image: SpImage,
  sp_txt: SpText
}

export default {
  name: 'SpecialPage',
  data() {
    return {
      loading: true,
      specialName: '',
      templateKey: '',
      componentList: [],
      componentMap,
      seoInfo: {
        title: '',
        keywords: '',
        description: ''
      }
    }
  },metaInfo() {
    return this.getMetaInfo
  },
  computed: {
     // VueMeta 元数据
    getMetaInfo() {
      return {
        title: this.seoInfo.seoTitle || '中国品牌网 - 专业品牌服务 | 国家市场监督管理总局主管',
        meta: [
          {
            name: 'keywords',
            content: this.seoInfo.seoKeywords || ''
          },
          {
            name: 'description',
            content: (this.seoInfo.seoDescription || '').substring(0, 200)
          }
        ]
      }
    },
    visibleComponents() {
      const countMap = {}
      return (this.componentList || [])
        .filter(item => item.isValid === 1 && componentMap[item.componentKey])
        .map(item => {
          const baseId = item.componentCode || item.componentKey
          const count = countMap[baseId] || 0
          countMap[baseId] = count + 1
          const suffix = count === 0 ? '' : `_${count}`
          return {
            ...item,
            uniqueKey: `${baseId}_${count}`,
            refName: `${baseId}${suffix}`,
            componentId: `${baseId}${suffix}`
          }
        })
    }
  },
  mounted() {
    this.loadSpecialInfo()
  },
  methods: {
    // 设置页面 SEO 信息
    setSEOInfo() {
      if (this.seoInfo.title) {
        document.title = this.seoInfo.title
      }
      
      // 更新或添加 keywords meta
      let keywordsMeta = document.querySelector('meta[name="keywords"]')
      if (keywordsMeta) {
        keywordsMeta.content = this.seoInfo.keywords
      } else {
        keywordsMeta = document.createElement('meta')
        keywordsMeta.name = 'keywords'
        keywordsMeta.content = this.seoInfo.keywords
        document.head.appendChild(keywordsMeta)
      }
      
      // 更新或添加 description meta
      let descriptionMeta = document.querySelector('meta[name="description"]')
      if (descriptionMeta) {
        descriptionMeta.content = this.seoInfo.description
      } else {
        descriptionMeta = document.createElement('meta')
        descriptionMeta.name = 'description'
        descriptionMeta.content = this.seoInfo.description
        document.head.appendChild(descriptionMeta)
      }
    },
    async loadSpecialInfo() {
      const specialCode = this.$route.query.specialCode || this.$route.params.specialCode
      if (!specialCode) {
        this.$router.replace({ name: 'not-found' })
        return
      }
      try {
        const data = await fetchSpecialInfo(specialCode)
        if (!data.componentList || !Array.isArray(data.componentList)) {
          this.$router.replace({ name: 'not-found' })
          return
        }
        this.specialName = data.specialName || ''
        this.templateKey = data.templateKey || ''
        this.componentList = data.componentList
        
        // 设置 SEO 信息
        if (data.seoTitle || data.seoKeywords || data.seoDescription) {
          this.seoInfo = {
            title: data.seoTitle || '',
            keywords: data.seoKeywords || '',
            description: data.seoDescription || ''
          }
        }
        
        await this.loadTemplateCss(this.templateKey)
        this.$nextTick(() => {
          this.applyConfigs()
          this.setSEOInfo()
          this.loading = false
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('getSpecialInfo error', error)
        this.$router.replace({ name: 'not-found' })
      }
    },
    async loadTemplateCss() {
      try {
        await import('./SpecialOne/assets/index.css')
        await import('./SpecialSix/assets/index.css')
        // SpecialSeven 是内联样式，不需要额外加载 CSS 文件
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('load template css error', e)
      }
    },
    applyConfigs() {
      this.visibleComponents.forEach(item => {
        if (item.componentKey === 'header' || item.componentKey === 'bottom') return
        const component = this.$refs[item.refName]
        if (!component || !item.configJson) return
        const target = Array.isArray(component) ? component[0] : component
        let config = {}
        try {
          config = JSON.parse(item.configJson)
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn(`component ${item.componentKey} configJson parse error`, e)
          return
        }
        Object.keys(config).forEach(key => {
          if (key in target.$data) {
            target.$data[key] = config[key]
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.special-root {
  min-height: 100vh;
  background: #fff;
}

.special-page {
  width: 1400px;
  margin: 0 auto;
}

.special-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.special-loading-text {
  color: rgba(0, 124, 68, 1);
  font-size: 24px;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
}
</style>
